/** Helpers for preview web builds (pr-<N>.preview.ommnio.com). */

export const previewPrFromDomain = domain => {
  const match = /^pr-(\d+)\.preview\./.exec(domain || '');
  return match ? match[1] : null;
};

export const isPreviewWebHost = domain => previewPrFromDomain(domain) != null;

/** True for webpack preview builds (APP_DOMAIN baked at build time). */
export const isPreviewBuild = () => isPreviewWebHost(process.env.APP_DOMAIN || '');
